/* istanbul ignore file */
export enum ReportFilterType {
    StringSearch = 'stringSearch',
    MultiSelect = 'multiSelect',
}
